"use client";

const _excluded = ["size"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React from "react";
import BaseIcon from "../../utils/BaseIcon";
const HospitalGraphicIcon = props => {
  const {
      size = 48
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    size: size
  }, otherProps, {
    "data-mesh-component": "HOSPITAL-GRAPHIC-ICON"
  }), /*#__PURE__*/React.createElement("g", {
    fill: iconFill,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.533 9.986a.5.5 0 0 1 .492.41l.008.09V13.8h7.166c1.072 0 1.95.83 2.028 1.881l.006.152V23.5a.5.5 0 0 1-.41.492l-.09.008H5.867a.5.5 0 0 1-.09-.992l.09-.008h2.566v-7.166c0-1.072.83-1.95 1.882-2.028l.152-.005h2.565l.001-3.314a.5.5 0 0 1 .5-.5M1.267 9.2a.5.5 0 0 1 .492.41l.008.09v13.8a.5.5 0 0 1-.992.09l-.008-.09V9.7a.5.5 0 0 1 .5-.5ZM21.2 14.8H10.467c-.533 0-.971.403-1.027.92l-.006.113L9.433 23h12.799v-7.166c0-.532-.402-.971-.92-1.027l-.113-.006Zm-6.9 5.152a.5.5 0 0 1 .09.992l-.09.008h-1.532a.5.5 0 0 1-.09-.992l.09-.008H14.3m4.6 0a.5.5 0 0 1 .09.992l-.09.008h-1.533a.5.5 0 0 1-.09-.992l.09-.008H18.9M5.868 18.4a.5.5 0 0 1 .09.992l-.09.008H4.334a.5.5 0 0 1-.09-.992l.09-.008h1.533m8.433-1.514a.5.5 0 0 1 .09.992l-.09.008h-1.533a.5.5 0 0 1-.09-.992l.09-.008H14.3m4.6 0a.5.5 0 0 1 .09.992l-.09.008h-1.534a.5.5 0 0 1-.09-.992l.09-.008H18.9M5.867 13.8a.5.5 0 0 1 .09.992l-.09.008H4.334a.5.5 0 0 1-.09-.992l.09-.008h1.533M7.4 0a5.1 5.1 0 1 1 0 10.2A5.1 5.1 0 0 1 7.4 0Zm0 1a4.1 4.1 0 1 0 0 8.2 4.1 4.1 0 0 0 0-8.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4 3.067a.5.5 0 0 1 .492.41l.008.09V4.6h1.034a.5.5 0 0 1 .09.992l-.09.008H7.9v1.034a.5.5 0 0 1-.992.09l-.008-.09V5.6H5.867a.5.5 0 0 1-.09-.992l.09-.008H6.9V3.567a.5.5 0 0 1 .5-.5"
  })));
};
HospitalGraphicIcon.displayName = "HospitalGraphicIcon";
HospitalGraphicIcon.iconName = "Hospital";
export default HospitalGraphicIcon;